module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-title', [_c('div', [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.value.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.value.description))]), _c('br'), _vm._v(" "), (!_vm.value.priceVariations) ? [_c('span', {
    staticClass: "item-price"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.value.price)))])] : [_c('span', {
    staticClass: "item-price"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.value.priceTable[0].price)))]), (_vm.value.priceTable.length > 1) ? _c('span', [_vm._v(" e mais " + _vm._s(_vm.value.priceTable.length - 1) + "...")]) : _vm._e()]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c8ea7fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/sharedComponents/item/Title.vue
// module id = 751
// module chunks = 2